import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, withCtx as _withCtx } from "vue"

const _hoisted_1 = ["ariaLabel"]
const _hoisted_2 = ["ariaLabel"]

import Icon from '@/components_new/Icon/Icon.vue'
import Link from '@/components_new/Link.vue'
import { ROUTE_NAMES } from '@/router/constants'

interface LogoProps {
    mode: 'short' | 'full' | 'default'
    noLink?: boolean
}

export default /*@__PURE__*/_defineComponent({
  __name: 'Logo',
  props: {
    mode: {},
    noLink: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.noLink ? 'div' : Link), _mergeProps(
            _ctx.noLink
                ? {}
                : {
                      to: { name: _unref(ROUTE_NAMES).MAIN },
                      color: 'purple-500',
                  }
        , {
    "data-interface-target": _ctx.noLink ? 'logo' : 'logo-link',
    class: [_ctx.$style.logo, _ctx.$style[`logo_${_ctx.mode}`]]
  }), {
    default: _withCtx(() => [
      (props.mode === 'short')
        ? (_openBlock(), _createElementBlock("svg", {
            key: 0,
            xmlns: "http://www.w3.org/2000/svg",
            fill: "none",
            viewBox: "0 0 28 26",
            ariaLabel: _ctx.$tr('logo.alt')
          }, _cache[0] || (_cache[0] = [
            _createElementVNode("path", {
              fill: "currentColor",
              d: "M0 21.143V4h6.54c3.611 0 6.54 2.943 6.54 6.571 0 3.629-2.929 6.572-6.54 6.572H4.265v4zM6.113 8H4.265v5.143h1.848c1.536 0 2.56-1.143 2.56-2.572C8.673 9.143 7.649 8 6.113 8m14.778-4H28v13.4c0 3.829-2.758 6.6-6.568 6.6h-5.659v-4.286h5.63c1.337 0 2.332-1 2.332-2.343v-.228H20.89c-3.61 0-6.54-2.943-6.54-6.572S17.281 4 20.891 4m-2.132 6.571c0 1.429 1.023 2.572 2.559 2.572h2.417V8h-2.417c-1.536 0-2.56 1.143-2.56 2.571"
            }, null, -1)
          ]), 8, _hoisted_1))
        : (props.mode === 'full')
          ? (_openBlock(), _createElementBlock("svg", {
              key: 1,
              xmlns: "http://www.w3.org/2000/svg",
              fill: "none",
              viewBox: "0 0 132 19",
              ariaLabel: _ctx.$tr('logo.alt')
            }, _cache[1] || (_cache[1] = [
              _createElementVNode("path", {
                fill: "currentColor",
                d: "M0 16.357V3.5h4.92a4.925 4.925 0 0 1 4.92 4.929 4.925 4.925 0 0 1-4.92 4.928H3.21v3zM4.6 6.5H3.208v3.857h1.39c1.156 0 1.926-.857 1.926-1.928 0-1.072-.77-1.929-1.926-1.929M14.764 13.357h-3.337V.5h3.337zM26.186 13.357h-4.92a4.925 4.925 0 0 1-4.921-4.928 4.925 4.925 0 0 1 4.92-4.929h4.92zm-4.6-3h1.39V6.5h-1.39c-1.155 0-1.925.857-1.925 1.929 0 1.071.77 1.928 1.925 1.928M32.735 18.5h-4.45v-3h4.236c1.134 0 1.968-.836 1.968-1.971v-.172h-6.204V3.5h3.21v6.857h2.994V3.5h3.21v10.243c0 2.743-2.097 4.757-4.964 4.757M44.246 3.5h5.348v10.05c0 2.871-2.075 4.95-4.942 4.95h-4.257v-3.214h4.236c1.005 0 1.754-.75 1.754-1.757v-.172h-2.14a4.925 4.925 0 0 1-4.92-4.928 4.925 4.925 0 0 1 4.92-4.929M42.64 8.429c0 1.071.77 1.928 1.926 1.928h1.818V6.5h-1.818c-1.156 0-1.926.857-1.926 1.929M60.968 13.357h-4.92a4.925 4.925 0 0 1-4.92-4.928 4.925 4.925 0 0 1 4.92-4.929h4.92zm-4.6-3h1.391V6.5h-1.39c-1.155 0-1.926.857-1.926 1.929 0 1.071.77 1.928 1.926 1.928M66.277 13.357h-3.209V3.5h9.948A4.395 4.395 0 0 1 77.4 7.893v5.464h-3.209V7.68c0-.643-.534-1.179-1.176-1.179h-1.177v6.857H68.63V6.5h-2.353zM88.67 13.357h-4.921a4.925 4.925 0 0 1-4.92-4.928 4.925 4.925 0 0 1 4.92-4.929h4.92zm-4.6-3h1.39V6.5h-1.39c-1.155 0-1.926.857-1.926 1.929 0 1.071.77 1.928 1.926 1.928M94.596 11.412a2.084 2.084 0 1 1-4.168.002 2.084 2.084 0 0 1 4.168-.002M120.876 13.357h-3.209V3.5h9.947A4.395 4.395 0 0 1 132 7.893v5.464h-3.209V7.68c0-.643-.535-1.179-1.177-1.179h-1.176v6.857h-3.209V6.5h-2.353zM100.546 13.385h4.249v-3h-3.929c-1.155 0-1.925-.857-1.925-1.928 0-1.072.77-1.929 1.925-1.929h3.929v-3h-4.249a4.925 4.925 0 0 0-4.92 4.929 4.925 4.925 0 0 0 4.92 4.928"
              }, null, -1),
              _createElementVNode("path", {
                fill: "currentColor",
                "fill-rule": "evenodd",
                d: "M111.13 13.537c2.823 0 5.112-2.297 5.112-5.13 0-2.834-2.289-5.131-5.112-5.131s-5.112 2.297-5.112 5.13c0 2.834 2.288 5.131 5.112 5.131m0-3.196a1.93 1.93 0 0 0 1.927-1.934 1.93 1.93 0 0 0-1.927-1.935 1.93 1.93 0 0 0-1.928 1.935c0 1.068.863 1.934 1.928 1.934",
                "clip-rule": "evenodd"
              }, null, -1)
            ]), 8, _hoisted_2))
          : (_openBlock(), _createBlock(Icon, {
              key: 2,
              name: "playgama_logo",
              class: _normalizeClass(_ctx.$style.logo_color),
              altText: _ctx.$tr('logo.alt')
            }, null, 8, ["class", "altText"]))
    ]),
    _: 1
  }, 16, ["data-interface-target", "class"]))
}
}

})